/**
 * 订单详情抽屉 - 金额卡片区块
 *
 * 展示订单总额、服务类型、已收款、待收余款、付款方式与明细合计。
 * 受控组件，不持有业务状态。
 */

import { pendingBalanceOf } from '../../../../../utils/paymentAmount';

interface Props {
  orderAmount: number | null;
  serviceTypeName: string | null;
  paidAmount: number | null;
  payMethod: string | null;
  itemsTotal: number;
}

export default function AmountCardSection({ orderAmount, serviceTypeName, paidAmount, payMethod, itemsTotal }: Props) {
  // 待收逐单夹零：存量脏单（实收越过应收）在这里显示 0 而不是负待收
  const pending = pendingBalanceOf(Number(orderAmount ?? 0), Number(paidAmount ?? 0));
  return (
    <>
      {orderAmount != null && (
        <div className="mx-5 mt-3 bg-teal-600 rounded-xl p-4 text-white">
          <div className="flex items-end justify-between mb-3">
            <div>
              <p className="text-teal-200 text-xs mb-1">订单总额</p>
              <p className="text-2xl font-bold">¥{Number(orderAmount).toLocaleString('zh-CN', { minimumFractionDigits: 2 })}</p>
            </div>
            {serviceTypeName && (
              <div>
                <p className="text-teal-200 text-xs mb-1">服务类型</p>
                <span className="inline-block text-xs bg-white/20 px-2.5 py-1.5 rounded-full text-teal-100">{serviceTypeName}</span>
              </div>
            )}
          </div>
          <div className="flex gap-4 pt-3 border-t border-teal-500">
            <div>
              <p className="text-teal-300 text-xs mb-0.5">已收款</p>
              <p className="text-sm font-semibold text-white">¥{Number(paidAmount ?? 0).toLocaleString('zh-CN', { minimumFractionDigits: 2 })}</p>
            </div>
            <div>
              <p className="text-teal-300 text-xs mb-0.5">待收余款</p>
              <p className={`text-sm font-semibold ${pending > 0 ? 'text-amber-300' : 'text-white'}`}>
                ¥{pending.toLocaleString('zh-CN', { minimumFractionDigits: 2 })}
              </p>
            </div>
            {payMethod && (
              <div>
                <p className="text-teal-300 text-xs mb-0.5">付款方式</p>
                {payMethod === '订单抵消' ? (
                  <span className="inline-flex items-center gap-1 text-xs px-2 py-0.5 bg-white/20 text-white rounded-full font-medium border border-white/30">
                    <i className="ri-exchange-dollar-line text-xs" />
                    订单抵消
                  </span>
                ) : (
                  <p className="text-sm font-semibold text-white">{payMethod}</p>
                )}
              </div>
            )}
            {itemsTotal > 0 && <div className="ml-auto"><p className="text-teal-300 text-xs mb-0.5">明细合计</p><p className="text-sm font-semibold text-white">¥{itemsTotal.toLocaleString('zh-CN', { minimumFractionDigits: 2 })}</p></div>}
          </div>
        </div>
      )}
    </>
  );
}